import { IconStarFilled } from '@picsart/design-system/foundation/icons/IconStarFilled';
import { IconStarOutline } from '@picsart/design-system/foundation/icons/IconStarOutline';
import { IconStarSemiFilled } from '@picsart/design-system/foundation/icons/IconStarSemiFilled';

import Description from '@picsart/growth-rc/Description';
import Title, { TextSizes } from '@picsart/growth-rc/Title';
import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';
import { TextElementTypes } from '@picsart/design-system/components/Text';

import { useColorScheme } from 'redesignedComponents/context/colorScheme';
import { withColorScheme } from 'redesignedComponents/decorators/withColorScheme';
import LinkButton from 'redesignedComponents/molecules/CTA/LinkButton';

import JSONLinkedData from 'components/JSONLinkedData/JSONLinkedData';
import { SchemaType } from 'components/JSONLinkedData/types';

import useLandingPropsStore from 'stores/landingPropsStore';
import { LandingCategory } from 'constants/enums';
import testIds from './testIds';

import type { RatingProps } from './types';

import useStyles from './styles';

const totalRates = 5;
const ratesArr = [...new Array(totalRates)];

const Rating = ({
  ratingValue,
  title,
  buttonProps,
  description,
  ratingCount,
  index,
  cmsId,
}: RatingProps) => {
  const colorScheme = useColorScheme();
  const category = useLandingPropsStore(x => x.category);
  const isMaximizer = category === LandingCategory.maximizer;
  const styles = useStyles({ colorScheme, isMaximizer });

  return (
    <>
      <JSONLinkedData
        data={{ ratingCount, ratingValue, title, description, pathname: window.location.pathname }}
        type={SchemaType.AggregateRating}
      />
      <div
        className={styles.root}
        data-testid={testIds.ratingRoot}
        data-pulse-section-group={`${index}_${cmsId}_rating`}
      >
        <HorizontalContainer className={styles.container}>
          {title && (
            <Title
              text={title}
              tag={TextElementTypes.H2}
              size={TextSizes.ExtraLarge}
              className={styles.title}
            />
          )}

          <div className={styles.starsReviews}>
            <div className={styles.starsReviewsContainer}>
              {ratesArr.map((arr, i) => {
                const key = i + ratingValue;
                if (i < ratingValue && ratingValue - i >= 1) {
                  return <IconStarFilled className={styles.stars} key={key} />;
                }
                if (i < ratingValue && ratingValue - i <= 1) {
                  return <IconStarSemiFilled className={styles.stars} key={key} />;
                }
                return <IconStarOutline className={styles.stars} key={key} />;
              })}
              <span className={styles.total}>
                {ratingValue}
                <span>/{totalRates}</span>
              </span>
            </div>
            <span className={styles.reviewsCount}>({ratingCount} reviews)</span>
          </div>
          {description && (
            <Description text={description} size={TextSizes.Large} className={styles.description} />
          )}
          {buttonProps && (
            <div className={styles.button}>
              <LinkButton {...buttonProps} />
            </div>
          )}
        </HorizontalContainer>
      </div>
    </>
  );
};

export default withColorScheme<RatingProps>(Rating);
